import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { selectedTimeZoneTemplate, statusOptions, timeZoneOptionTemplate, timeZonesOptions } from '../../../utils/mics';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';

const StoreSystemIdFilter = (props) => {
    
    const { handleSearch, handleReset, onFormValuesChange } = props;

    const dispatch = useDispatch();
    const filters = useSelector((state) => state.storeSysId.filters);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            storeId: filters?.storeId || '',
            idType: filters?.idType || '',
            idMin: filters?.idMin || '',
            idMax: filters?.idMax || '',
            idPrefix: filters?.idPrefix || '',
            idValue: filters?.idValue || '',
            date_from: filters?.date_from || '',
            date_till: filters?.date_till || '',
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                date_from: values.date_from  ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
            };
            dispatch(appActions.STORESYSID_SET_FILTERS_REQUEST(values));
            handleSearch(data);
        },
    });

    const handleClear = () => {
        dispatch(appActions.STORESYSID_SET_FILTERS_REQUEST({}));
        formik.resetForm();
        onFormValuesChange(null);
        handleReset();
    };

    const handleChange = (e) => {
        formik.handleChange(e);
        if (onFormValuesChange) {
            const values = { ...formik.values, [e.target.name]: e.target.value };
             const data = {
                ...values,
                date_from: values.date_from  ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
            };
            onFormValuesChange(data);
        }
    }

    const isDateTillUpdated = useRef(false); // Track if update is needed

    useEffect(() => {
        if (
            formik.values.date_from &&
            (!formik.values.date_till || new Date(formik.values.date_till) < new Date(formik.values.date_from))
        ) {
            if (!isDateTillUpdated.current) { // Prevent infinite loop
                formik.setFieldValue("date_till", formik.values.date_from);
                isDateTillUpdated.current = true; // Mark as updated
            }
        } else {
            isDateTillUpdated.current = false; // Reset when update is not needed
        }
    }, [formik, formik.values.date_from]); // Only trigger when date_from changes
        
    const renderFormArea = () => {
        return (
            <>
                <div className="p-fluid formgrid grid w-full">

                    <div className="field col-12 md:col-3">
                        <label htmlFor="storeId">Store ID</label>
                        <InputText id="storeId" name="storeId" type="number" value={formik.values.storeId} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="idType">Type</label>
                        <InputText id="idType" name="idType" value={formik.values.idType} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="idMin">Minmum</label>
                        <InputText id="idMin" name="idMin" type="number" value={formik.values.idMin}  onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="idMax">Maximum</label>
                        <InputText id="idMax" name="idMax" type="number" value={formik.values.idMax} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="idPrefix">Prefix</label>
                        <InputText id="idPrefix" name="idPrefix" type="number" value={formik.values.idPrefix} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="idValue">Current Value</label>
                        <InputText id="idValue" name="idValue" type="number" value={formik.values.idValue} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date From</label>
                        <Calendar id="date_from" name="date_from" value={formik.values.date_from} onChange={handleChange} dateFormat="dd-mm-yy" showIcon maxDate={new Date()}/>
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date Till</label>
                        <Calendar id="date_till" name="date_till" value={formik.values.date_till} onChange={handleChange} dateFormat="dd-mm-yy" showIcon minDate={formik.values.date_from}/>
                    </div>

                </div>
                <div className="grid px-2 py-4 flex-row-reverse gap-10">
                    <Button type="submit" icon="pi pi-search" label="Search" severity="success" outlined className="p-button-success mr-2 tp" data-pr-tooltip="Search" />
                    <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset Filter" label="Reset Filter" severity="secondary" outlined  onClick={handleClear} />
                </div>
            </>
        );
    };
    return <form onSubmit={formik.handleSubmit}>{renderFormArea()}</form>;
};

export default StoreSystemIdFilter;
